import React from 'react';

const ExpandAllIcon = ({ className, style, width = 32, height = 32 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path d="M9.73047 9.86572L15.9995 16.1348L22.2686 9.86572" stroke="#BBFD3B" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.73047 16.8657L15.9995 23.1348L22.2686 16.8657" stroke="#BBFD3B" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default ExpandAllIcon;
